import {
  Ref,
  watch,
} from 'vue';
import { MaybeNull } from '@/shared/types';

export interface ReadingPlanLastPoint {
  readingPlanId: string;
  dayNumber: number;
  slideIndex: number;
  updatedAt: string;
}

interface UseTrackReadingPlanPointProps {
  readingPlanId?: Ref<string>;
  dayNumber?: Ref<number>;
  slideIndex?: Ref<number>;
}

export const useTrackReadingPlanPoint = (props: UseTrackReadingPlanPointProps) => {
  const STORAGE_KEY = 'reading-plan:last-point';

  const setReadingPlanLastPoint = () => {
    if (props.dayNumber === undefined || props.slideIndex === undefined) {
      return;
    }

    if (!props.readingPlanId?.value || isNaN(props.dayNumber.value) || isNaN(props.slideIndex.value)) {
      return;
    }

    const lastPoint: ReadingPlanLastPoint = {
      readingPlanId: props.readingPlanId.value,
      dayNumber: props.dayNumber.value,
      slideIndex: props.slideIndex.value,
      updatedAt: new Date().toISOString(),
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(lastPoint));
  };

  watch(
    [() => props.readingPlanId?.value, () => props.dayNumber?.value, () => props.slideIndex?.value],
    () => {
      setReadingPlanLastPoint();
    },
    {
      immediate: true,
    },
  );

  return {
    setReadingPlanLastPoint,
  };
};

export const getReadingPlanLastPoint = (): MaybeNull<ReadingPlanLastPoint> => {
  const STORAGE_KEY = 'reading-plan:last-point';

  const lastPointString = localStorage.getItem(STORAGE_KEY);

  if (!lastPointString) {
    return null;
  }

  try {
    return JSON.parse(lastPointString);
  } catch (e) {
    console.error('Failed to parse reading plan last point from localStorage', e);

    return null;
  }
};
